// extracted by mini-css-extract-plugin
export default {"placeholder":"yDnVs","blink":"ebIqA"};